import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { toggleCreativeFilterModal } from '../../../../../../slices/modals/reducer';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label } from "reactstrap";
import ClearAllFilters from '../../../../../../Components/Common/ClearAllFilters';
import { setCreativesFirstLoad, setCreativesHasMore, setCreativesPage, setFilteredCreatives, setScrolledCreatives } from '../../../../../../slices/campaigns/reducer';
import Sizes from './Sizes';
import { setCreativeFigmaBeforePreview, setHtmlCreativesPreview } from '../../../../../../slices/campaigns/thunk';
import { sendMessageForPreview } from '../../../../../../slices/campaigns/helper';

function FilterModal() {
  const dispatch = useDispatch();
  const selectFilterState = createSelector((state) => state.Modal, (state) => state.creativeFilterModal);
  const creativeFilterModal = useSelector(selectFilterState);

  const selectCreatives = createSelector(state => state.Campaign, state => ({
    creatives: state.creatives,
    filteredCreatives: state.filteredCreatives,
    currentCampaign: state.currentCampaign
  }));
  const { creatives, filteredCreatives, currentCampaign } = useSelector(selectCreatives);

  const [isSelectedAll, setIsSelectedAll] = useState(false);
  const [selectedSizes, setSelectedSizes] = useState([]);

  // useEffect(() => {
  //   if (creatives) {
  //     setSelectedSizes(creatives.map((item, idx) => idx));
  //   }
  // }, [creatives]);

  useEffect(() => {
    if (creatives) {
      setSelectedSizes(creatives.map((item, idx) => idx));
    }
  }, [creativeFilterModal]);

  useEffect(() => {
    if (selectedSizes?.length === creatives?.length) {
      setIsSelectedAll(true);
    } else if (selectedSizes?.length === 0) {
      setIsSelectedAll(false);
    }
  }, [selectedSizes]);

  function handleSelect(item, selectedIdx) {
    const foundSize = selectedSizes.find((item, idx) => selectedIdx === item);
    if (foundSize !== undefined) {
      setSelectedSizes(selectedSizes.filter((item, idx) => selectedIdx !== item));
    } else {
      setSelectedSizes([...selectedSizes, selectedIdx]);
    }
  }

  function selectAll() {
    const allSizes = creatives.map((item, idx) => idx);
    setSelectedSizes(allSizes);
    setIsSelectedAll(true);
  }

  function deselectAll() {
    setSelectedSizes([]);
    setIsSelectedAll(false);
  }

  async function handleSubmit() {
    let filteredSizes = selectedSizes.map(index => creatives[parseInt(index)]).filter(item => item !== undefined).sort((a, b) => {
      const [widthA] = a.size.split("x").map(Number);
      const [widthB] = b.size.split("x").map(Number);
      return widthB - widthA;
    });
    dispatch(setFilteredCreatives(filteredSizes));
    if (currentCampaign?.bannerType === 'html') {
      dispatch(setCreativesPage(1));
      dispatch(setCreativesHasMore(false));
      dispatch(setCreativesFirstLoad(false));
      dispatch(setScrolledCreatives([]));
      dispatch(setScrolledCreatives(filteredSizes));
    }
  }

  async function clearFilter() {
    deselectAll();
    dispatch(setFilteredCreatives([]));
    if (currentCampaign?.bannerType === 'html') {
      // setHtmlCreativesPreview(creatives);
      dispatch(setCreativesPage(1));
      dispatch(setCreativesHasMore(true));
      dispatch(setCreativesFirstLoad(false));
      dispatch(setScrolledCreatives([]));
    }
    setSelectedSizes([]);
  }

  function isChecked(item, idx) {
    if (selectedSizes.includes(idx)) {
      return true;
    } else {
      return false;
    }
  }

  function setHtmlCreativesPreview(creativesArr) {
    if (Array.isArray(creativesArr) && creativesArr.length > 0) {
      let i = 0;
      do {
        sendMessageForPreview(creativesArr[i].preview, creativesArr[i], creativesArr[i]._id, '');
        i++;
      } while (i < creativesArr.length);
    }
  }

  return (
    <Modal isOpen={creativeFilterModal} toggle={() => dispatch(toggleCreativeFilterModal())} centered size='sm'>
      <ModalHeader className='p-3' toggle={() => dispatch(toggleCreativeFilterModal())}>
        <b>Filters</b>
      </ModalHeader>
      <ModalBody className='px-3' style={{ minHeight: "300px" }}>
        <Sizes
          creatives={creatives}
          selectedSizes={selectedSizes}
          handleSelect={handleSelect}
          isSelectedAll={isSelectedAll}
          selectAll={selectAll}
          deselectAll={deselectAll}
          isChecked={(item, idx) => isChecked(item, idx)}
          columnWidth='4'
        />
      </ModalBody>
      <ModalFooter className='d-flex align-items-center justify-content-between border border-top border-dashed py-3 px-3'>
        <ClearAllFilters onClick={clearFilter} />
        <button className='btn btn-success' onClick={handleSubmit}>Apply</button>
      </ModalFooter>
    </Modal>
  )
}

export default FilterModal;
